<template>
  <div class="orderlist bj order-container">
    <div class="title">
      <div class="seach">
        <div class="inputs">
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="bjsearch"
            @click="Refresh"
          ></el-button>
        </div>
        <div class="inputs" v-if="role == 'tdc'">
          <el-select
            v-model="from1.sale_id"
            clearable
            filterable
            placeholder="所属销售"
          >
            <el-option
              :label="item.fullname"
              :value="item.id"
              :key="item.id"
              v-for="item in salelist"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-input
            v-model="from1.fullname"
            placeholder="请输入客户名称"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
          <el-input
            v-model="from1.member_remark"
            placeholder="请输入客户备注"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
          <el-input
            v-model="from1.mobile"
            placeholder="请输入客户电话"
            clearable
          ></el-input>
        </div>
        <div class="inputs" v-if="role == 'tdc'">
          <el-select
            v-model="from1.delivery_id"
            clearable
            placeholder="请选择自提点"
          >
            <el-option
              :key="item.id"
              v-for="item in arrList"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-input
            v-model="from1.order_no"
            placeholder="请输入订单编号"
            clearable
          ></el-input>
        </div>
        <div class="mr10" style="display: flex;">
          <div style="line-height: 40px;">
            支付时间：
          </div>
          <el-date-picker
            @change="payChange"
            v-model="pay_at"
            :time-arrow-control="true"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            range-separator="—"
            start-placeholder="支付时间起"
            end-placeholder="支付时间止"
          >
          </el-date-picker>
        </div>
        <div class="inputs">
          <el-select v-model="from1.state" clearable placeholder="请选择状态">
            <el-option label="全部订单状态" value=""></el-option>
            <el-option label="待付款" value="1"></el-option>
            <el-option label="已付款" value="2"></el-option>
            <el-option label="已取消" value="3"></el-option>
            <el-option label="已生成供货单" value="4"></el-option>
            <el-option label="已完成" value="5"></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-button @click="search" type="primary" icon="el-icon-search"
            >查询</el-button
          >
          <el-button @click="exportHandle" type="warning" icon="el-icon-upload2"
            >导出</el-button
          >
        </div>
      </div>
    </div>
    <div class="total" v-if="isShow && from.pay_start && from.pay_end">
      <span class="total-item">订单总金额：{{ totalAmount }}元</span>
      <span class="total-item">总件数：{{ totalCount }}件</span>
      <span class="total-item">总吨数：{{ totalTons }}吨</span>
      <span class="total-item">总下单人数：{{ totalMemberCount }}人</span>
    </div>
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="订单编号">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.order_no) }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="订单创建时间">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_at" align="center" label="客户名称">
          <template slot-scope="scope" v-if="scope.row.member">
            {{ $empty.empty(scope.row.member.fullname) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_at" align="center" label="客户备注">
          <template slot-scope="scope" v-if="scope.row.member">
            {{ $empty.empty(scope.row.member.logisitcs_member_remark) }}
          </template>
        </el-table-column>

        <el-table-column prop="pay_at" align="center" label="支付时间">
          <template slot-scope="scope">
            {{ $empty.time(scope.row.pay_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">待付款</span>
            <span v-else-if="scope.row.state == 2">已付款</span>
            <span v-else-if="scope.row.state == 3">已取消</span>
            <span v-else-if="scope.row.state == 4">已生成供货单</span>
            <span v-else-if="scope.row.state == 5">已完成</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="订单金额">
          <template slot-scope="scope">
            {{ $empty.empty(tool.format_money(scope.row.order_amt)) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="城市仓">
          <template
            slot-scope="scope"
            v-if="
              scope.row.store_delivery && scope.row.store_delivery.logistics
            "
          >
            {{ $empty.empty(scope.row.store_delivery.logistics.name) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="自提点">
          <template slot-scope="scope" v-if="scope.row.store_delivery">
            {{ $empty.empty(scope.row.store_delivery.name) }}
          </template>
        </el-table-column>
        <el-table-column prop="sale_name" align="center" label="所属销售">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.sale_name) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'ReceivingOrderDetail',
                query: { id: scope.row.id },
              }"
              class="main-color pointer text-none"
              >查看详情
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import { BASE } from "@/api";
import url from "url";
export default {
  name: "orderlist",
  components: {},
  data() {
    return {
      //列表新建页面初始参数
      loading: true,
      pay_at: "",
      from: {
        mobile: "",
        sale_id: "",
        delivery_id: "",
        fullname: "",
        order_no: "",
        pay_start: "",
        pay_end: "",
        state: "",
        member_remark:'',
        page: 1,
        pageSize: 10,
      },
      from1: {
        mobile: "",
        sale_id: "",
        delivery_id: "",
        fullname: "",
        order_no: "",
        pay_start: "",
        pay_end: "",
        state: "",
         member_remark:'',
        page: 1,
        pageSize: 10,
      },
      role: sessionStorage.getItem("manageIsdentity"),
      tableData: [],
      arrList: [],
      currentPage: 1,
      total: 0,
      totalAmount: 0,
      totalCount: 0,
      totalTons: 0,
      totalMemberCount: 0,
      isShow:false,
      //列表页面不同功能参数
      authentication: [
        {
          id: -1,
          name: "全部",
        },
        {
          id: 0,
          name: "未认证",
        },
        {
          id: 1,
          name: "审核中",
        },
        {
          id: 2,
          name: "审核成功",
        },
        {
          id: 3,
          name: "审核失败",
        },
      ],
      options: [
        {
          value: "logistics",
          label: "集配",
        },
        {
          value: "delivery",
          label: "自提",
        },
      ],
      options1: [],
      storelist: [],
      selflist: [],
      logistics_id: "",
      list: [],
      list1: [],
      salelist: [],
    };
  },
  created() {
    if (window.location.href.indexOf("?") > -1) {
      /** 历史丢参问题，修复 start */
      const url = this.tool.getUrl(window.location.href);
      // 无效的值
      const invalid = ["", null, undefined, "null", "undefined"];
      url.page = (invalid.includes(url.page) && 1) || url.page;
      url.pageSize = (invalid.includes(url.pageSize) && 10) || url.pageSize;
      /** 历史丢参问题，修复 end */
      this.from = url;
      this.from1 = url;

      if (this.from.pay_start && this.from.pay_end) {
        this.pay_at = [this.from.pay_start, this.from.pay_end];
      } else {
        const { startStr, endStr } = this.getDefaultPayRange();
        this.pay_at = [startStr, endStr];
        this.from.pay_start = startStr;
        this.from.pay_end = endStr;
        this.from1.pay_start = startStr;
        this.from1.pay_end = endStr;
      }

      this.currentPage = Number(this.from1.page);
      this.from1.pageSize = Number(this.from1.pageSize);
      this.from1.sale_id = Number(this.from1.sale_id)
        ? Number(this.from1.sale_id)
        : "";
    } else {
      const { startStr, endStr } = this.getDefaultPayRange();
      this.pay_at = [startStr, endStr];
      this.from.pay_start = startStr;
      this.from.pay_end = endStr;
      this.from1.pay_start = startStr;
      this.from1.pay_end = endStr;
    }

    if (this.role == "tdc") {
      this.from.delivery_id = Number(this.from.delivery_id)
        ? Number(this.from.delivery_id)
        : "";
      this.from1.delivery_id = Number(this.from1.delivery_id)
        ? Number(this.from1.delivery_id)
        : "";
      this.getDeliveryList();
      this.getsaleselectlist();
    }
    this.hqlist();
  },
  methods: {
    getDefaultPayRange() {
      const pad2 = (n) => String(n).padStart(2, "0");
      const format = (d) =>
        `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(
          d.getDate()
        )} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;

      const now = new Date();
      const today14 = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        14,
        0,
        0
      );
      const before14 = now.getTime() < today14.getTime();

      const start = before14
        ? new Date(today14.getTime() - 24 * 60 * 60 * 1000)
        : today14;
      const end = before14
        ? today14
        : new Date(today14.getTime() + 24 * 60 * 60 * 1000);

      return {
        startStr: format(start),
        endStr: format(end),
      };
    },
    getsaleselectlist() {
      this.$api.SalesP.saleselectlist().then((res) => {
        this.salelist = res.data;
      });
    },
    getDeliveryList() {
      this.$api.delivery.deliverylist().then((res) => {
        console.log(res, "获取数据");
        this.arrList = res.data;
      });
    },
    exportHandle() {
      let tmpForm = this.tool.DeepCopy({}, this.from1);

      const query = { ...tmpForm };
      delete query.page;
      delete query.pageSize;
      // const params = url.format({ query });

      if (this.role == "tdc") {
        this.$api.biexport.tdcorderexport(query).then((res) => {
          this.goExportCenter();
        });
      } else {
        this.$api.biexport.deliveryorderexport(query).then((res) => {
          this.goExportCenter();
        });
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    search() {
      this.from.page = 1;
      this.from1.page = 1;
      this.currentPage = 1;
      this.from = this.tool.DeepCopy({}, this.from1);
      let form = this.tool.DeepCopy({}, this.from1);
      if (this.role == "delivery" && form.hasOwnProperty("delivery_id")) {
        delete form.delivery_id;
      }
      this.tool.getResult(form, window.location.href);
      this.isShow = false;
      this.hqlist();
    },
    Refresh() {
      const { startStr, endStr } = this.getDefaultPayRange();
      this.pay_at = [startStr, endStr];
      this.from = {
        mobile: "",
        sale_id: "",
        delivery_id: "",
        fullname: "",
        order_no: "",
        pay_start: startStr,
        pay_end: endStr,
        state: "",
         member_remark:'',
        page: 1,
        pageSize: 10,
      };
      this.from1 = {
        mobile: "",
        sale_id: "",
        delivery_id: "",
        fullname: "",
        order_no: "",
        pay_start: startStr,
        pay_end: endStr,
        state: "",
         member_remark:'',
        page: 1,
        pageSize: 10,
      };
      this.currentPage = 1;
      let form = this.tool.DeepCopy({}, this.from1);
      if (this.role == "delivery" && form.hasOwnProperty("delivery_id")) {
        delete form.delivery_id;
      }
      this.tool.getResult(form, window.location.href);
      this.hqlist();
      this.isShow = false;
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      let form = this.tool.DeepCopy({}, this.from1);
      if (this.role == "delivery" && form.hasOwnProperty("delivery_id")) {
        delete form.delivery_id;
      }
      this.tool.getResult(form, window.location.href);
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      let form = this.tool.DeepCopy({}, this.from1);
      if (this.role == "delivery" && form.hasOwnProperty("delivery_id")) {
        delete form.delivery_id;
      }
      this.tool.getResult(form, window.location.href);
      this.hqlist();
    },
    payChange(val) {
      console.log(val);
      if (val) {
        this.from1.pay_start = val[0];
        this.from1.pay_end = val[1];
      } else {
        this.from1.pay_start = "";
        this.from1.pay_end = "";
      }
      this.isShow = false;
    },
    hqlist() {
      this.loading = true;
      let form = this.tool.DeepCopy({}, this.from);
      if (this.role == "delivery" && form.hasOwnProperty("delivery_id")) {
        delete form.delivery_id;
      }
      this.$api.delivery.deliveryOrderlist(form).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;

        const orderStatistics = res.data.orderStatistics;
        this.totalMemberCount = orderStatistics.memberCount;
        this.totalAmount = orderStatistics.orderAmount;
        this.totalCount = orderStatistics.orderGoodsCount;
        this.totalTons = orderStatistics.orderGrossWeight;

        this.isShow = !!(this.from.pay_start && this.from.pay_end);
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.order-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .title {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
    padding-bottom: 0;

    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;

      .inputs {
        max-width: 207px;
        margin-right: 8px;
        margin-bottom: 20px;
      }
    }

    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;

    box-sizing: border-box;

    .titlname {
      font-size: 17px;
      color: #21c2ac;
      margin-bottom: 25px;
    }

    .imgs {
      display: flex;

      .imglist {
        width: 165px;
        height: 123px;
        border: 1px dashed #a4adc5;
        padding: 14px 8px;
        text-align: center;
        border-radius: 7px;
        box-sizing: border-box;
        margin-right: 16px;

        .div {
          margin-top: 20px;
          padding-bottom: 20px;
        }

        // img{
        //     width: 100%;
        //     height: 100%;
        // }
      }
    }

    .disply {
      display: flex;
      margin-bottom: 22px;
    }

    .mr {
      margin-right: 31px;
    }

    .iteminput {
      display: flex;
      align-items: center;

      .wen {
        width: 77px;
        margin-right: 24px;
        color: #000;
        font-size: 14px;
        text-align: right;
      }

      .el-input {
        width: 302px;
      }
    }
  }

  .colors {
    color: #fa884c;
  }

  .times {
    margin-right: 8px;
  }

  // .el-picker-panel {
  //   left: 1245px !important;
  // }
  .total{
    background: #fff;
    padding: 10px;
    font-size: 16px;

    .total-item {
      display: inline-block;
      margin-right: 20px;
    }

    .total-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
